import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import useStyles from './styles';

interface progressProperties {
  percentUpload: number;
  width?: string;
  innerPadding?: number;
  outerPadding?: number;
}
const ProgressBar = ({
  percentUpload,
  width = '100%',
  innerPadding = 2,
  outerPadding = 1,
}: progressProperties) => {
  const classes = useStyles();
  return (
    <Box p={outerPadding} display="flex" width="100%" alignItems="center">
      <Typography>progress</Typography>
      <Box p={innerPadding} width={width}>
        <LinearProgress
          className={classes.progress}
          variant="determinate"
          color="secondary"
          value={percentUpload}
        />
      </Box>
    </Box>
  );
};
export default ProgressBar;
